module.exports = __webpack_public_path__ + "img/element_1.64f25ff9.png";